@if (isLoading) {
  <div class="loading-container">
    <places-spinner class="loading-img">
      <span translate>Loading map</span>
    </places-spinner>
  </div>
}

@if (!isLoading) {
  <places-mapbox-map [defaultMapStyle]="defaultMapStyle" [defaultCenter]="defaultCenter">
  </places-mapbox-map>
}

@if ((isEditTrafficDeviationContext$ | async) !== true) {
  <places-map-style-controls [mapStyles]="mapStyles" [defaultMapStyle]="defaultMapStyle"></places-map-style-controls>
  <div class="draw-control-wrapper">
    <places-map-draw-controls></places-map-draw-controls>
  </div>
}